import React from 'react';

const isChunkLoadFailure = (error) => /ChunkLoadError|Loading chunk|dynamically imported module/i.test(
  String(error?.name || '') + String(error?.message || '')
);

const lazyWithRetry = (factory, routeKey) => {
  let modulePromise = null;
  const load = () => {
    if (modulePromise) return modulePromise;
    modulePromise = (async () => {
      try {
        const module = await factory();
        if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(`route-retry:${routeKey}`);
        return module;
      } catch (error) {
        modulePromise = null;
        const retryKey = `route-retry:${routeKey}`;
        const canReload = typeof window !== 'undefined'
          && typeof sessionStorage !== 'undefined'
          && navigator.onLine !== false
          && isChunkLoadFailure(error)
          && !sessionStorage.getItem(retryKey);

        if (canReload) {
          sessionStorage.setItem(retryKey, '1');
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      }
    })();
    return modulePromise;
  };

  const LazyComponent = React.lazy(load);
  // Navigation links can warm the chunk on pointer hover or keyboard focus.
  LazyComponent.preload = load;
  return LazyComponent;
};

export default lazyWithRetry;
